import { SystemStyleObject } from "@mui/system";
import { ButtonCurrentValProps, ThemeV2 } from "../../../util/types";

export const actionBtn = (
  theme: ThemeV2,
  isSelected: boolean,
  currentVal: ButtonCurrentValProps,
): SystemStyleObject => {
  const color = isSelected
    ? theme.tokens.color.action.primaryText
    : theme.tokens.color.action.primary;
  const backgroundColor = isSelected
    ? theme.tokens.color.action.primary
    : theme.tokens.color.surface.card;
  return {
    ...(!currentVal?.image
      ? {
          padding: `${theme.tokens.spacing["1"] / 2}px ${theme.tokens.spacing["3"]}px`,
        }
      : { wordBreak: "break-word", maxWidth: { xs: "112px", md: "100%" } }),

    color,
    backgroundColor,
    border: `1px solid ${theme.tokens.color.action.primary}`,
    lineHeight: theme.tokens.typography.lineHeight.normal,
    fontSize: {
      sm: `${theme.tokens.typography.size.lg}px`,
      xs: `${theme.tokens.typography.size.sm}px`,
    },
    borderRadius: `${theme.tokens.shape.radius.md}px`,
    fontWeight: `${theme.tokens.typography.weight.regular}`,
    textTransform: "none",
    margin: `${theme.tokens.spacing["1"] / 2}px`,
    boxShadow: theme.tokens.elevation["2"],
    "&:hover": { color, backgroundColor },
    "&:disabled": {
      borderColor: theme.tokens.color.border.default,
      backgroundColor: theme.tokens.color.text.secondary,
      color: theme.tokens.color.text.inverse,
      cursor: "not-allowed",
      "&:hover": {
        backgroundColor: theme.tokens.color.border.default,
        color: theme.tokens.color.text.inverse,
      },
    },
  };
};
